import { render, staticRenderFns } from "./bankacc.vue?vue&type=template&id=53180d86&scoped=true&"
import script from "./bankacc.vue?vue&type=script&lang=js&"
export * from "./bankacc.vue?vue&type=script&lang=js&"
import style0 from "./bankacc.vue?vue&type=style&index=0&id=53180d86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53180d86",
  null
  
)

export default component.exports